/*
 *
 *  actions
 *
 */

import {
  //LOAD_VIDEO_TEAM
  LOAD_PARTIES,
  LOAD_PARTIES_SUCCESS,
  LOAD_PARTIES_ERROR,
  CREATE_PARTIES,
  CREATE_PARTIES_SUCCESS,
  CREATE_PARTIES_ERROR,
  UPDATE_PARTIES,
  UPDATE_PARTIES_SUCCESS,
  UPDATE_PARTIES_ERROR,
  DELETE_PARTIES,
  DELETE_PARTIES_SUCCESS,
  DELETE_PARTIES_ERROR,
  LOAD_PARTIES_RECORDS_META_DATA,
  LOAD_PARTIES_RECORDS_META_DATA_SUCCESS,
  LOAD_PARTIES_RECORDS_META_DATA_ERROR,
  LOAD_PARTIES_COLLECT,
  LOAD_PARTIES_COLLECT_SUCCESS,
  LOAD_PARTIES_COLLECT_ERROR,
  LOAD_PARTIES_PAY,
  LOAD_PARTIES_PAY_SUCCESS,
  LOAD_PARTIES_PAY_ERROR,
  LOAD_PARTIES_TRANSACTION,
  LOAD_PARTIES_TRANSACTION_SUCCESS,
  LOAD_PARTIES_CATEGORY,
  LOAD_PARTIES_CATEGORY_SUCCESS,
  LOAD_PARTIES_CATEGORY_ERROR,
  CREATE_PARTIES_CATEGORY,
  CREATE_PARTIES_CATEGORY_SUCCESS,
  CREATE_PARTIES_CATEGORY_ERROR,
  LOAD_PARTIES_TRANSACTION_ERROR,

  //ledger statement
  LOAD_PARTIES_LEDGER_STATEMENT,
  LOAD_PARTIES_LEDGER_STATEMENT_SUCCESS,
  LOAD_PARTIES_LEDGER_STATEMENT_ERROR,
  LOAD_STATE_LIST,
  LOAD_STATE_LIST_SUCCESS,
  LOAD_STATE_LIST_ERROR,
} from "./constants";

// load parties
export function loadParties(partiesList) {
  return {
    type: LOAD_PARTIES,
    partiesList,
  };
}

export function loadPartiesSuccess(parties_list, success) {
  return {
    type: LOAD_PARTIES_SUCCESS,
    parties_list,
    success,
  };
}

export function loadPartiesError(error) {
  return {
    type: LOAD_PARTIES_ERROR,
    error,
  };
}

// load parties
export function loadPartiesCollect(partiesList) {
  return {
    type: LOAD_PARTIES_COLLECT,
    partiesList,
  };
}

export function loadPartiesCollectSuccess(parties_collect_list, success) {
  return {
    type: LOAD_PARTIES_COLLECT_SUCCESS,
    parties_collect_list,
    success,
  };
}

export function loadPartiesCollectError(error) {
  return {
    type: LOAD_PARTIES_COLLECT_ERROR,
    error,
  };
}

// load parties
export function loadPartiesPay(partiesList) {
  return {
    type: LOAD_PARTIES_PAY,
    partiesList,
  };
}

export function loadPartiesPaySuccess(parties_pay_list, success) {
  return {
    type: LOAD_PARTIES_PAY_SUCCESS,
    parties_pay_list,
    success,
  };
}

export function loadPartiesPayError(error) {
  return {
    type: LOAD_PARTIES_PAY_ERROR,
    error,
  };
}

// Category

export function loadPartiesCategory(categoryList) {
  return {
    type: LOAD_PARTIES_CATEGORY,
    categoryList,
  };
}

export function loadPartiesCategorySuccess(category_list, success) {
  return {
    type: LOAD_PARTIES_CATEGORY_SUCCESS,
    category_list,
    success,
  };
}

export function loadPartiesCategoryError(error) {
  return {
    type: LOAD_PARTIES_CATEGORY_ERROR,
    error,
  };
}

//category list
export function createPartiesCategoryList(categoryList) {
  return {
    type: CREATE_PARTIES_CATEGORY,
    categoryList,
  };
}

export function createPartiesCategoryListSuccess(categoryList, success) {
  return {
    type: CREATE_PARTIES_CATEGORY_SUCCESS,
    categoryList,
    success,
  };
}

export function createPartiesCategoryListError(error) {
  return {
    type: CREATE_PARTIES_CATEGORY_ERROR,
    error,
  };
}


// load parties
export function createPartiesList(partiesList) {
  return {
    type: CREATE_PARTIES,
    partiesList,
  };
}

export function createPartiesListSuccess(partiesList, success) {
  return {
    type: CREATE_PARTIES_SUCCESS,
    partiesList,
    success,
  };
}

export function createPartiesListError(error) {
  return {
    type: CREATE_PARTIES_ERROR,
    error,
  };
}
// load parties
export function updatePartiesList(partiesList) {
  return {
    type: UPDATE_PARTIES,
    partiesList,
  };
}

export function updatePartiesListSuccess(partiesList, success) {
  return {
    type: UPDATE_PARTIES_SUCCESS,
    partiesList,
    success,
  };
}

export function updatePartiesListError(error) {
  return {
    type: UPDATE_PARTIES_ERROR,
    error,
  };
}
// load parties
export function deletePartiesList(partiesList) {
  return {
    type: DELETE_PARTIES,
    partiesList,
  };
}

export function deletePartiesListSuccess(partiesList, success) {
  return {
    type: DELETE_PARTIES_SUCCESS,
    partiesList,
    success,
  };
}

export function deletePartiesListError(error) {
  return {
    type: DELETE_PARTIES_ERROR,
    error,
  };
}

// load parties transaction
export function loadPartiesTransaction(partiesList) {
  return {
    type: LOAD_PARTIES_TRANSACTION,
    partiesList,
  };
}

export function loadPartiesTransactionSuccess(
  parties_transaction_list,
  success
) {
  return {
    type: LOAD_PARTIES_TRANSACTION_SUCCESS,
    parties_transaction_list,
    success,
  };
}

export function loadPartiesTransactionError(error) {
  return {
    type: LOAD_PARTIES_TRANSACTION_ERROR,
    error,
  };
}


// load parties
export function loadLedgerStatmentList(partiesList) {
  return {
    type: LOAD_PARTIES_LEDGER_STATEMENT,
    partiesList,
  };
}

export function loadLedgerStatmentListSuccess(
  ledger_statement_list,
  success
) {
  return {
    type: LOAD_PARTIES_LEDGER_STATEMENT_SUCCESS,
    ledger_statement_list,
    success,
  };
}

export function loadLedgerStatmentListError(error) {
  return {
    type: LOAD_PARTIES_LEDGER_STATEMENT_ERROR,
    error,
  };
}

export function loadPartiesRecordsMetaData() {
  return {
    type: LOAD_PARTIES_RECORDS_META_DATA,
  };
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadPartiesRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_PARTIES_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  };
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadPartiesRecordsMetaDataError(error) {
  return {
    type: LOAD_PARTIES_RECORDS_META_DATA_ERROR,
    error,
  };
}

// load parties
export function loadStateList(stateList) {
  return {
    type: LOAD_STATE_LIST,
    stateList,
  };
}

export function loadStateListSuccess(state_list, success) {
  return {
    type: LOAD_STATE_LIST_SUCCESS,
    state_list,
    success,
  };
}

export function loadStateListError(error) {
  return {
    type: LOAD_STATE_LIST_ERROR,
    error,
  };
}

const actions = {
  loadParties,
  loadPartiesSuccess,
  loadPartiesError,

  loadPartiesCollect,
  loadPartiesCollectSuccess,
  loadPartiesCollectError,

  loadPartiesPay,
  loadPartiesPaySuccess,
  loadPartiesPayError,
  loadStateList,
  loadStateListSuccess,
  loadStateListError,

  loadPartiesCategory,
  loadPartiesCategorySuccess,
  loadPartiesCategoryError,

  createPartiesCategoryList,
  createPartiesCategoryListSuccess,
  createPartiesCategoryListError,

  loadPartiesTransaction,
  loadPartiesTransactionSuccess,
  loadPartiesTransactionError,

  createPartiesList,
  createPartiesListSuccess,
  createPartiesListError,

  updatePartiesList,
  updatePartiesListSuccess,
  updatePartiesListError,

  deletePartiesList,
  deletePartiesListSuccess,
  deletePartiesListError,

  loadPartiesRecordsMetaData,
  loadPartiesRecordsMetaDataSuccess,
  loadPartiesRecordsMetaDataError,

  loadLedgerStatmentList,
  loadLedgerStatmentListSuccess,
  loadLedgerStatmentListError,
};

export default actions;
